import React from "react"

import { Button, Modal, Spinner } from "react-bootstrap"
import Autocomplete from "react-google-autocomplete"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import { Disclosure } from "@headlessui/react"
import { ChevronUpIcon } from "@heroicons/react/20/solid"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import {
  ArrowLongLeftIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
  XMarkIcon
} from "@heroicons/react/24/solid"

import { apiDeletePMA, apiGetAllPMA, apiUpdatePMA } from "core/api"
import { googleMapAPIKEY, mapOptions } from "core/plugins/config"
import {
  convertAustralianNumber,
  isAustralianNumber
} from "core/plugins/validator"
import { ROUTES } from "core/routes"
function AgencyAdminList() {
  const navigation = useNavigate()
  const [sIndex, setSIndex] = React.useState(false)
  const routeTo = (route) => {
    navigation(route)
  }
  const [payload, setPayload] = React.useState(false)
  const filter = (e) => {
    setPayload(e.target.value)
    let filtered = list.filter((item) =>
      item.CompanyName.includes(e.target.value)
    )
    setList(filtered)

    if (e.target.value.length === 0) {
      clearFilters()
      setPayload(false)
      setList(defaultList)
    }
  }

  const onPlaceSelected = (place) => {
    if (place && place?.formatted_address) {
      setEditPayload((prevState) => ({
        ...prevState,
        Address: place?.formatted_address
      }))
    }
  }

  const [loading, setLoading] = React.useState(false)
  React.useEffect(() => {
    setLoading(true)
    apiGetAllPMA().then((response) => {
      setList(response)
      setLoading(false)
    })
  }, [])

  const [list, setList] = React.useState(false)
  const [defaultList, setDefaultList] = React.useState(false)
  const clearFilters = () => {
    setPayload(false)
    apiGetAllPMA().then((response) => {
      setList(response)
      setDefaultList(response)
    })
  }
  const [showEditModal, setShowEditModal] = React.useState(false)

  const handleCloseEditModal = () => {
    setShowEditModal(false)
  }
  const [editPayload, setEditPayload] = React.useState({
    CompanyName: "",
    AgencyAdminName: "",
    Email: "",
    Mobile: "",
    Address: "",
    PMAID: ""
  })
  const [editLoader, setEditLoader] = React.useState(false)

  const submitEdit = (e) => {
    e.preventDefault()
    if (
      editPayload.Mobile.length > 0 &&
      !isAustralianNumber(editPayload.Mobile)
    ) {
      toast.error(
        "Please enter a valid Australian phone number eg +61234567890 / 0298765432"
      )
      return
    }

    setEditLoader(true)
    apiUpdatePMA(editPayload)
      .then((response) => {
        toast.success("Organisation admin updated")
        apiGetAllPMA().then((response) => {
          setList(response)
          setEditLoader(false)
        })
        handleCloseEditModal()
      })
      .finally(() => {
        setEditLoader(false)
      })
  }

  const deletePMA = (id) => {
    apiDeletePMA(id).then((response) => {
      if (response) {
        toast.success("Organisation admin deleted successfully ")
      }
      apiGetAllPMA().then((response) => {
        setList(response)
      })
    })
  }

  const onChangeEditPaylod = (e) => {
    setEditPayload((prevState) => ({
      ...prevState,
      [e.target.name]:
        e.target.name === "Mobile"
          ? convertAustralianNumber(e.target.value)
          : e.target.value
    }))
  }

  return (
    <>
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        className="edit-modal"
        
      >
          <Modal.Header closeButton>
          <Modal.Title>Edit Organisation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
         
          <div className="spacer-sm"></div>
          <form onSubmit={submitEdit}>
            <div className="input-element">
              <div className="input-normal">
                <input
                  value={editPayload.CompanyName}
                  name="CompanyName"
                  type="text"
                  placeholder="Organisation name"
                  required
                  onChange={onChangeEditPaylod}
                ></input>
              </div>
            </div>

            <div className="input-element">
              <div className="input-normal">
                <input
                  value={editPayload.AgencyAdminName}
                  name="AgencyAdminName"
                  type="text"
                  placeholder="Organisation admin name"
                  required
                  onChange={onChangeEditPaylod}
                ></input>
              </div>
            </div>

            <div className="input-element">
              <div className="input-normal">
                <input
                  value={editPayload.Email}
                  name="Email"
                  disabled
                  type="email"
                  placeholder="Email"
                  required
                  onChange={onChangeEditPaylod}
                ></input>
              </div>
            </div>

            <div className="input-element">
              <div className="input-normal">
                <input
                  value={editPayload.Mobile}
                  name="Mobile"
                  type="text"
                  placeholder="Phone number"
                  required
                  onChange={onChangeEditPaylod}
                ></input>
              </div>
            </div>

            <div className="input-element">
              <div className="input-normal">
                <Autocomplete
                  options={mapOptions}
                  defaultValue={editPayload.Address}
                  required
                  apiKey={googleMapAPIKEY}
                  onPlaceSelected={(place) => onPlaceSelected(place)}
                />
              </div>
            </div>

            <div className="input-element text-center">
              <button
                type="submit"
                className="primary-button primary-button-small no-animation"
              >
                <div className="button-text">
                  {editLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    "Update"
                  )}
                </div>
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <div className="container inner-page ">
        <div className="spacer-lg"></div>
        
        <div className="d-flex flex-column">
          <div className="row justify-content-center">
          <div className="col-lg-7 col-md-7">
            <p className="admin-type">inCommunity Admin</p>
            </div>
            <div className="col-lg-7 col-md-7 d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center">
                <div
                  className="left-round-button"
                  onClick={() => routeTo(ROUTES.IA_DASHBOARD)}
                >
                  <ArrowLongLeftIcon />
                </div>
                <h2 className="text-left">Organisation Admins</h2>
              </div>

              <div className="input-element text-center">
                <button
                  onClick={() => routeTo("/IA/add-agency-admin")}
                  type="submit"
                  className="primary-button button-add no-animation"
                  style={{ marbinBottom: 0 }}
                >
                  <div className="button-text"></div>
                  <div className="right-icon">
                    <PlusIcon />
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            
            <div className="col-lg-7 col-md-7">
              <div className="spacer-lg"></div>
              <div className="accordian-list">
                <div className="d-flex sub-title-with-icon align-items-center">
                  <div className="icon-left">
                  <img src="/images/org-admin-icon1.png" alt=""/>
                  </div>
                  <h3 style={{margin:0}}>
                    Organisation Admins &nbsp;
                    {loading ? <Spinner animation="border" size="sm" /> : ""}
                  </h3>
                </div>
                <div className="spacer-sm"></div>
                <div className="">
                  <div>
                    <div className="search-bar">
                      <div className="search-input">
                        <input
                          value={payload ? payload : ""}
                          onChange={filter}
                          type="text"
                          placeholder="Search an organisation"
                        ></input>
                        <div className="right-icon" onClick={clearFilters}>
                          {payload && payload.length > 0 ? (
                            <XMarkIcon />
                          ) : (
                            <MagnifyingGlassIcon />
                          )}
                        </div>
                      </div>
                    </div>

                    {list &&
                      list.map((item, i) => (
                        <Disclosure
                          as="div"
                          className={
                            sIndex === i ? "acc-wrapper open" : "acc-wrapper"
                          }
                          key={item.PMAID}
                        >
                          {({ open }) => (
                            <>
                              <Disclosure.Button
                                className="d-flex acc-wrapper-button"
                                onClick={() => {
                                  setSIndex(i)
                                }}
                              >
                                <div>
                                  <span className="text-orange">
                                    {item.CompanyName}
                                  </span>{" "}
                                </div>
                                <ChevronUpIcon
                                  className={`${open ? "" : "rotate-180"}`}
                                />
                              </Disclosure.Button>
                              <Disclosure.Panel className="acc-panel">
                             
                                <p>
                                  <span className="text-orange">
                                    Organisation Admin Name
                                  </span>
                                  <br />
                                  <span>{item.OrganisationAdminName}</span>
                                </p>
                                <p>
                                  <span className="text-orange">Email</span>
                                  <br />
                                  <span>{item.Email}</span>
                                </p>

                                <p>
                                  <span className="text-orange">Mobile</span>
                                  <br />
                                  <span>{item.Mobile}</span>
                                </p>

                                <p>
                                  <span className="text-orange">Address</span>
                                  <br />
                                  <span>{item.Address} </span>
                                </p>

                                <div className="row justify-content-center">
                                  <div className="col-md-12 d-flex justify-content-center">
                                    <div>
                                      <Button
                                        className="btn-edit"
                                        onClick={() => {
                                          setShowEditModal(true)
                                          setEditPayload(item)
                                        }}
                                      >
                                        <span>
                                          <PencilIcon />
                                        </span>
                                        Edit
                                      </Button>
                                      <Button
                                        className="btn-delete"
                                        onClick={() => deletePMA(item.SSMOID)}
                                      >
                                        <span>
                                          <TrashIcon />
                                        </span>{" "}
                                        Delete
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </Disclosure.Panel>
                            </>
                          )}
                        </Disclosure>
                      ))}

                    {list && list.length === 0 && (
                      <div className="empty-list-data">
                        <div className="spacer-sm"></div>
                        <h4>No organisation admins found</h4>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            textAlign: "center"
          }}
        >
          <a
            className="d-block"
            href="/"
            style={{
              fontSize: 10,
              color: "#fff"
            }}
          >
            PM Assist
          </a>
        </div>
      </div>
    </>
  )
}

export default AgencyAdminList
